/**
 * Created by casteloyee on 2017/7/20.
 */
import React from 'react';
import API_URL from '../../common/url';
import SearchSelect from '../common/SearchSelectCrf';

class PatientCodeSearchInput extends React.Component {
    constructor(props) {
        super(props);
        if(props.defaultValue){
            this.state = {
                data: [{text: props.defaultValue, value: 0, patientCode: props.defaultValue}],
            };
        } else {
            this.state = {
                data: [],
            };
        }
    };

    parserData = dt => {
        const data = [];
        if (dt.datas && dt.datas.length > 0) {
            dt.datas.map(r => {
                data.push({
                    text: r.patientCode,
                    value: r.patientId,
                    ...r
                });
            });
        }
        this.setState({
            data,
        });
    };

    handleSelect = sel => {
        this.state.data.map( item => {
            if (item.value == sel.key){
                this.props.handleSelectPatient(item);
            }
        });
    };

    handleChane = (value) => {
        if (this.props.handleInputSelect) {
            this.props.handleInputSelect(value);
        }
    }

    render() {
        const url =  this.props.url ? this.props.url : `${API_URL.execute.queryPatientCodeList}`;
        let params;
        if (this.props.params) {
            params = { showError: 0, ...this.props.params };
        } else {
            params = {showError: 0};
        }
        const {data} = this.state; 
        return (
            <SearchSelect url={url}
                          style={this.props.style}
                          searchKey='keyword'
                          searchParam={params}
                          sourceData={data}
                          onChange={this.handleChane}
                          parserData={this.parserData}
                          handleSelect = {this.handleSelect}
                          initValue = {this.props.initValue}
                          className="patientCode"
            />
        );
    };

}

export default PatientCodeSearchInput;



// WEBPACK FOOTER //
// ./src/components/execute/PatientCodeSearchInput.js